import React, { useState, useEffect} from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import BarChartIcon from '@mui/icons-material/BarChart';
import PieChartIcon from '@mui/icons-material/PieChart';
import BubbleChartIcon from '@mui/icons-material/BubbleChart';
import InsertChartIcon from '@mui/icons-material/InsertChart';

import ItemWiseReportHsn from '../ARC_Reconciliation/Purchase/ItemWiseReport/ItemWiseReport';
import AgeingRecivableReport from './AgingReport/Ageing_Recivable_Report';
import AgeingPayableReport from './AgingReport/Ageing_payble_Report';
import ItcAvailReport from '../ARC_Reconciliation/Purchase/ITC_Avaial_Report/ItcReport';
import ItcReversalReport from '../ARC_Reconciliation/Purchase/ITC_Reversal_Report/itc_reversal';
import VendorCancellation from './VendoreCancellation/VendorCancellation';
import MultiMonth from './MultiMonth/MultiMonth';
import HsnSummaryReport from '../ARC_Reconciliation/Purchase/HSN Summary Report/HsnSummaryReport';
import Gtsr9InwardComparison from '../ARC_Reconciliation/Purchase/GSTR-9 Reconciliation/inward';
import Gtsr9OutwardComparison from '../ARC_Reconciliation/Purchase/GSTR-9 Reconciliation/Outward';
import GSTComputationReport from '../ARC_Reconciliation/Purchase/GstComputationReport/Gst_computation_report';
import RCMReport from '../ARC_Reconciliation/Purchase/RCM_Report/rcmReport';
import TdsReport from './TDS_Applicability_Report/TdsReport';
import GstLedgers from './GSTLedger/GstLedger';
import RcmReport from './rcmReport/rcmReport';



const toggleButtonStyle = {
    flex: 1,
    border: 0,
    borderRadius: '30px',
    textTransform: 'none',
    px: 3,
    py: 1,
    fontWeight: 600,
    color: '#000000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
    whiteSpace: 'nowrap', // Prevent wrapping
    minWidth: '140px', 
    '&.Mui-selected': {
        backgroundColor: 'var(--main-btn-color)',
        color: '#ffffff',
    },
    '&:hover': {
        backgroundColor: 'transparent',
    },
    '&.Mui-selected:hover': {
        backgroundColor: 'var(--main-btn-color)',
    },
};

export default function ArcReports() {
    const history = useHistory();
    const location = useLocation();

    const [alignment, setAlignment] = useState('working_capital');
    const [tabIndex, setTabIndex] = useState(0);
    const [sitemapData, setSitemapData] = useState(null);

    useEffect(() => {
        const storedSitemap = localStorage.getItem("sitemap");
        if (storedSitemap) {
            try {
                const parsed = JSON.parse(storedSitemap);
                setSitemapData(parsed);
            } catch (e) {
                console.error("Failed to parse sitemap from localStorage", e);
                setSitemapData(null);
            }
        }
    }, [location.pathname]);

    const wrokingCapitalAccess = sitemapData?.["REPORT ANALYTICS"]?.['WORKING CAPITAL'] || [];
    const statutoryComplianceAccess = sitemapData?.["REPORT ANALYTICS"]?.['STATUTORY COMPLIANCE'] || [];
    const purchaseAccess = sitemapData?.["ARC RECONCILLIATION"]?.PURCHASE || [];

    const workingCapitalReportOptions = [
        wrokingCapitalAccess?.includes("ITEM WISE REPORT") && {
            label: 'Item wise report',
            icon: <BarChartIcon />,
            path: '/itemWiseReportHsn',
            component: ItemWiseReportHsn
        },
        wrokingCapitalAccess?.includes("AGEING REPORT") && {
            label: 'Ageing Receivable',
            icon: <PieChartIcon />,
            path: '/ageing_recivable_report_dashboard',
            component: AgeingRecivableReport
        },
        wrokingCapitalAccess?.includes("AGEING REPORT") && {
            label: 'Ageing Payable',
            icon: <BubbleChartIcon />,
            path: '/ageing_payable_report_dashboard',
            component: AgeingPayableReport
        },
    ].filter(Boolean);

    const statutoryComplianceReportOptions = [
        statutoryComplianceAccess?.includes("ITC AVAILABILITY REPORT") && {
            label: 'ITC Availability Report',
            icon: <BarChartIcon />,
            path: '/itcAvailReportBooks',
            component: ItcAvailReport
        },
        statutoryComplianceAccess?.includes("ITC REVERSAL REPORT") && {
            label: 'ITC Reversal Report',
            icon: <PieChartIcon />,
            path: '/itcRevarsalReport',
            component: ItcReversalReport
        },
        statutoryComplianceAccess?.includes("VENDOR CANCELLATION REPORT") && {
            label: 'Vendor Cancellation Report',
            icon: <BubbleChartIcon />,
            path: '/VendorCancellation',
            component: VendorCancellation
        },
        statutoryComplianceAccess?.includes("MULTIMONTH REPORT") && {
            label: 'Multi-Month Report',
            icon: <InsertChartIcon />,
            path: '/MultiMonth',
            component: MultiMonth
        },
        statutoryComplianceAccess?.includes("HSN SUMMARY REPORT") && {
            label: 'HSN Summary Report',
            icon: <BarChartIcon />,
            path: '/HsnSummaryReport',
            component: HsnSummaryReport
        },
        statutoryComplianceAccess?.includes("GST INWARD COMPARISON") && {
            label: 'Inward comparison',
            icon: <PieChartIcon />,
            path: '/Inward_comparison',
            component: Gtsr9InwardComparison
        },
        statutoryComplianceAccess?.includes("GST OUTWARD COMPARISON") && {
            label: 'Outward comparison',
            icon: <BubbleChartIcon />,
            path: '/Outward_comparison',
            component: Gtsr9OutwardComparison
        },
        statutoryComplianceAccess?.includes("GST COMPUTATION REPORT") && {
            label: 'GST Computation Report',
            icon: <InsertChartIcon />,
            path: '/gst_computation_report',
            component: GSTComputationReport
        },
        statutoryComplianceAccess?.includes("RCM REPORT") && {
            label: 'RCM Report',
            icon: <BarChartIcon />,
            path: '/RcmSummary',
            component: RCMReport
        },
        statutoryComplianceAccess?.includes("GST LEDGERS") && {
            label: 'GST Ledgers',
            icon: <PieChartIcon />,
            path: '/GstLedgers',
            component: GstLedgers
        },
         statutoryComplianceAccess?.includes("TDS APPLICABILITY REPORT") && {
            label: 'TDS Applicability Report',
            icon: <BarChartIcon />,
            path: '/tdsApplicabilityReport',
            component: TdsReport
        },
         statutoryComplianceAccess?.includes("ITC/RCM ELIGIBLITY REPORT") && {
            label: 'ITC/RCM ELIGIBLITY REPORT',
            icon: <BarChartIcon />,
            path: '/rcmReport',
            component: RcmReport
        },

    ].filter(Boolean);


    useEffect(() => {
        const currentPath = location.pathname;
        const workingCapitalIndex = workingCapitalReportOptions.findIndex(tab => tab.path === currentPath);
        const statutoryComplianceIndex = statutoryComplianceReportOptions.findIndex(tab => tab.path === currentPath);

        if (workingCapitalIndex !== -1) { // if path is related to working_capital report
            setAlignment('working_capital');
            setTabIndex(workingCapitalIndex);
        } else if (statutoryComplianceIndex !== -1) { // if path is related to statutory_compliance report
            setAlignment('statutory_compliance');
            setTabIndex(statutoryComplianceIndex);
        } else if (workingCapitalReportOptions.length > 0) {
            setAlignment('working_capital');
            setTabIndex(0);
            history.replace(workingCapitalReportOptions[0].path);
        } else if (statutoryComplianceReportOptions.length > 0) {
            setAlignment('statutory_compliance');
            setTabIndex(0);
            history.replace(statutoryComplianceReportOptions[0].path);
        }
    }, [location.pathname, workingCapitalReportOptions, statutoryComplianceReportOptions, history]);

    const tabsToShow = alignment === 'working_capital' ? workingCapitalReportOptions : statutoryComplianceReportOptions;

    const handleAlignment = (event, newAlignment) => {
        if (newAlignment === alignment) return;
        if (newAlignment !== alignment) {
            setAlignment(newAlignment);
            const newTabs = newAlignment === 'working_capital' ? workingCapitalReportOptions : statutoryComplianceReportOptions;
            if (!newTabs.length) return;
            setTabIndex(0);
            history.push(newTabs[0].path);
        }
    };

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
        const selectedTab = tabsToShow[newValue];
        if (selectedTab?.path) {
            history.push(selectedTab.path);
        }
    };

    const activeTab = [...workingCapitalReportOptions, ...statutoryComplianceReportOptions].find(tab => tab.path === location.pathname);
    const ActiveComponent = activeTab?.component;


    return (
        <Box sx={{ fontFamily: "'Inter', sans-serif", width: '100%' }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'nowrap',
                    gap: 2,
                    mb: 4,
                    overflowX: 'auto',
                }}
            >
                {((workingCapitalReportOptions && workingCapitalReportOptions.length > 0) || (statutoryComplianceReportOptions && statutoryComplianceReportOptions.length > 0)) && (
                    <ToggleButtonGroup
                        value={alignment}
                        exclusive
                        onChange={handleAlignment}
                        aria-label="Data Toggle"
                        sx={{
                            backgroundColor: '#ffffff',
                            borderRadius: '30px',
                            p: '3px',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                            display: 'flex',
                            width: 'fit-content',
                            '.MuiToggleButton-root': {
                                textTransform: 'uppercase',
                                fontWeight: 550,
                                fontFamily: '"Dosis", sans-serif',
                                letterSpacing: '1px',
                                fontSize: '13px',
                            },
                        }}
                    >
                        {(workingCapitalReportOptions && workingCapitalReportOptions.length > 0) && (
                            <ToggleButton value="working_capital" aria-label="working_capital" sx={toggleButtonStyle}>
                                Working Capital
                            </ToggleButton>
                        )}
                        {(statutoryComplianceReportOptions && statutoryComplianceReportOptions.length > 0) && (
                            <ToggleButton value="statutory_compliance" aria-label="statutory_compliance" sx={toggleButtonStyle}>
                                Statutory Compliance
                            </ToggleButton>
                        )}
                    </ToggleButtonGroup>
                )}


                {(tabsToShow && tabsToShow.length > 0) ? (
                    <Tabs
                        value={tabIndex}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="GST/TDS Tabs"
                        sx={{
                            backgroundColor: '#ffffff',
                            borderRadius: '30px',
                            p: '4px',
                            maxWidth: '80%',
                            overflowX: 'auto',
                            '.MuiTab-root': {
                                width: 'auto',
                                textTransform: 'uppercase',
                                fontWeight: 550,
                                fontFamily: '"Dosis", sans-serif',
                                letterSpacing: '1px',
                                fontSize: '13px',
                                minHeight: '35px',
                                borderRadius: '20px',
                                px: 2.5,
                                py: 0.9,
                                color: '#212121',
                                '&:hover': {
                                    backgroundColor: 'var(--sub-btn-color)',
                                    color: '#fff !important',
                                },
                            },
                            '.Mui-selected': {
                                backgroundColor: 'var(--sub-btn-color)',
                                color: '#fff !important',
                            },
                            '.MuiTabs-indicator': {
                                display: 'none',
                            },
                            '.MuiTabs-scrollButtons': {
                                backgroundColor: 'var(--sub-btn-color)',
                                color:'#FFFFFF',
                                borderRadius: '50%',
                                '&.Mui-disabled': {
                                    opacity: 0.3,
                                },
                            },
                        }}
                    >
                        {tabsToShow.map((tab, index) => (
                            <Tab key={index} icon={tab.icon} iconPosition="start" label={tab.label} />
                        ))}
                    </Tabs>
                ) : null}
            </Box>

            {(tabsToShow && tabsToShow.length > 0) ? (
                <Box>
                    <ActiveComponent/>
                </Box>
            ) : (
                <Box
                    sx={{
                        textAlign: 'center',
                        mt: 20,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <InfoOutlinedIcon sx={{ fontSize: 64, color: '#90a4ae', mb: 2 }} />
                    <Box sx={{ fontSize: '18px', color: '#607d8b', fontFamily: '"Dosis", sans-serif' }}>
                        Please activate the {alignment ? alignment.toLocaleUpperCase() : ''} Report Services to access.
                    </Box>

                </Box>
            )}
        </Box>
    );
}
